import authRequest from '@ertelecom/ui-react/components/requests/authRequest';
import { isAxiosError } from '~/src/helpers/whoseError';
import { captureException } from '@sentry/node';

export interface IResp {
    ok: boolean,
    accessToken?: string,
    refreshToken?: string,
    error?: string,
}

interface IParams {
    secret: string,
    domain: string,
    agreement: string,
    clientId: string,
    timestamp: string,
    grantType: string,
}

/**
 * Получение токена по сикрету
 * @param {string} domain
 * @return {Promise<IResp | null>}
 */
export const getTokenBySecret = async(domain: string, params?: IParams): Promise<IResp> => {
    try {
        const resp = await authRequest(domain).get('/person/secret', { params });
        return {
            ok: true,
            accessToken: resp?.data.access_token,
            refreshToken: resp?.data.refresh_token,
        };
    } catch (err) {
        if (isAxiosError(err)) {
            return ({
                ok: false,
                error: err?.response?.data?.message,
            });
        }

        captureException(err);

        return ({
            ok: false,
            error: 'Внутренняя ошибка сервера',
        });
    }
};
